import React from "react";
import { t } from "ttag";

import type { DraftJsContentState } from "@reactivated";

import { RichText } from "../RichText";

import styles from "./Newsletter.module.scss";

// Replaces the form, which held focus, so move focus here instead of letting
// it fall back to the top of the page.
export const NewsletterSuccess = ({
    message,
}: {
    message: DraftJsContentState | null;
}) => {
    const ref = React.useRef<HTMLDivElement>(null);
    React.useEffect(() => ref.current?.focus(), []);

    return (
        <div ref={ref} role="status" tabIndex={-1} className={styles.success}>
            {message ? (
                <RichText value={message} />
            ) : (
                <p className={styles.successMessage}>
                    {t`Thanks — you're subscribed.`}
                </p>
            )}
        </div>
    );
};
